document.addEventListener('alpine:init', () => {
  Alpine.data('CartPackagingPreference', () => {
    return {
      updating: false,
      packagingPreference: getExpiringStorageItem('cart_packaging_preference') || 'Jewelry box and pouch',
      async init() {
        const preference = await this.getPackagingPreference();

        if (!preference) {
          this.updatePackagingPreference();
        }

        this.$watch('packagingPreference', (value) => {
          setExpiringStorageItem('cart_packaging_preference', value, daysInMs(3));
          this.updatePackagingPreference();
        });
      },
      async getPackagingPreference() {
        const cart = await fetch(theme.routes.root_url + 'cart.js');
        const cartData = await cart.json();
        return cartData.attributes?.['Packaging Preference'];
      },
      async updatePackagingPreference() {
        this.updating = true;

        try {
          await fetch(theme.routes.cart_update_url, {
            ...fetchConfigDefaults(),
            body: JSON.stringify({
              attributes: {
                'Packaging Preference': this.packagingPreference,
              },
            }),
          });
        } catch (error) {
          console.error('Failed to update packaging preference:', error);
        }

        this.updating = false;
      },
    };
  });
});
